import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import config from './../package.json'
import i18n from './utils/i18n'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import directive from './directives' // 引入自定义指令
import smartComponentV3 from '@sgs/smart-components-v3'
import '@sgs/smart-components-v3/dist/style.css'
import '@sgs/smart-components-v3/dist/assets/style_components/index.scss'
import Avue from '@sgs/avue3'
import '@sgs/avue3/lib/index.css'
import dffComponentV3 from '@sgs/dff-components-v3'
import '@sgs/dff-components-v3/dist/style.css'
import { authVerify } from '@/utils/authVerify'
import { preloadBaseMessages } from '@/utils/authService'
import 'virtual:svg-icons-register'
import './permission'
// import './assets/style/tailwind.css'

/* 
平替组件库样式 
todo 与@sgs/smart-components-v3/dist/assets/style_components/index.scss合并 
*/
// import './assets/style/common.scss'
// import './assets/style/index.css'
import '@sgs/smart-components-v3/dist/assets/style_components/common.scss'
import '@sgs/smart-components-v3/dist/assets/style_web/common.scss'
/* web3 业务通用样式 */
import './assets/style/web3.scss'

async function initApp() {
  const appObj = createApp(App)
  appObj.use(store)
  appObj.use(router)
  appObj.use(i18n)
  await authVerify()
  if (
    document.location.pathname == '/web/register/info' ||
    document.location.pathname == '/web/login'||
    document.location.pathname == '/web/auth/sso'
  ) {
    // 白名单不走权限验证
  } else {
    await preloadBaseMessages()
  }
  return appObj
}
initApp().then((app) => {
  const currentEnv = import.meta.env.MODE

  if (['uat', 'production'].includes(currentEnv)) {
    Sentry.init({
      app,
      dsn: 'https://509fe13088cb463ce7c8601c4cceb282@sentry.sgsonline.com.cn/43',
      release: config.version,
      environment: currentEnv,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracePropagationTargets: ['localhost'],
        }),
        new Sentry.Replay(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        'ResizeObserver loop completed with undelivered notifications.',
        'ResizeObserver loop limit exceeded',
        'Non-Error promise rejection captured with value: cancel',
      ],
    })
  }

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  // 注册自定义指令
  directive(app)
  app.use(smartComponentV3)
  app.use(dffComponentV3)
  app.use(ElementPlus)
  app.use(Avue,{formOption:{},locale:'en'})
  app.mount('#app')
})
